import React from "react";

export default React.createContext({
    query: "",
    handleDeleteMovie: () => {},
})